import useWidth from './useWidth';

const useResponsiveButtonSize = () => {
  const width = useWidth();
  switch (width) {
    default:
      return 'medium';
  }
};

export default useResponsiveButtonSize;
